import { render, staticRenderFns } from "./TopPicks.vue?vue&type=template&id=6b296104&scoped=true"
import script from "./TopPicks.vue?vue&type=script&lang=js"
export * from "./TopPicks.vue?vue&type=script&lang=js"
import style0 from "./TopPicks.vue?vue&type=style&index=0&id=6b296104&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b296104",
  null
  
)

export default component.exports